// Angular imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// 3rd party imports
import {
    DxBoxModule,
    DxButtonModule,
    DxChartModule,
    DxDataGridModule,
    DxLoadPanelModule,
    DxPieChartModule,
    DxPopupModule,
    DxSelectBoxModule,
    DxToolbarModule,
    DxFormModule
} from 'devextreme-angular';

// CC-Common imports
import { CCCommonModule, CCDataGridFeaturesModule } from 'cc-common';
import { SharedModule } from '../shared-module/shared.module';
import { ManagementCommonModule } from '../management-common/management-common.module';

// Service imports
import { SharedWidgetsService } from './_services/shared-widgets.service';
import { WidgetContextFactoryService } from '../_services/data-services/widget-context-factory.service';

// Component imports
import { PlattedLotPieChartComponent } from './components/platted-lot-pie-chart/platted-lot-pie-chart.component';
import { PlattedLotWidgetComponent } from './widgets/platted-lot-widget/platted-lot-widget.component';
import { ConveyanceBarChartComponent } from './components/conveyance-bar-chart/conveyance-bar-chart.component';
import { ConveyanceWidgetComponent } from './widgets/conveyance-widget/conveyance-widget.component';
import { UserDashboardBarChartComponent } from './components/user-dashboard-bar-chart/user-dashboard-bar-chart.component';
import { UserDashboardDetailsComponent } from './components/user-dashboard-bar-chart/user-dashboard-details/user-dashboard-details.component';
import { UserDashboardCommunityDetailsComponent } from './components/user-dashboard-bar-chart/user-dashboard-community-details/user-dashboard-community-details.component';
import { UserDashboardWidgetComponent } from './widgets/user-dashboard-widget/user-dashboard-widget.component';

@NgModule({
    imports: [
        CommonModule,
        CCCommonModule,
        CCDataGridFeaturesModule,
        SharedModule,
        ManagementCommonModule,
        DxBoxModule,
        DxButtonModule,
        DxChartModule,
        DxDataGridModule,
        DxLoadPanelModule,
        DxPieChartModule,
        DxPopupModule,
        DxSelectBoxModule,
        DxToolbarModule,
        DxFormModule
    ],
    declarations: [
        PlattedLotPieChartComponent,
        PlattedLotWidgetComponent,
        ConveyanceBarChartComponent,
        ConveyanceWidgetComponent,
        UserDashboardBarChartComponent,
        UserDashboardDetailsComponent,
        UserDashboardCommunityDetailsComponent,
        UserDashboardWidgetComponent
    ],
    exports: [PlattedLotWidgetComponent, ConveyanceWidgetComponent, UserDashboardWidgetComponent],
    providers: [SharedWidgetsService, WidgetContextFactoryService],
    entryComponents: [PlattedLotWidgetComponent, ConveyanceWidgetComponent, UserDashboardWidgetComponent]
})
export class SharedWidgetsModule {}
